export class PromocodeConstants{
    public static readonly maxBonusValue: number = 50;
    public static readonly minPurchaseAmount: number = 5;
    public static readonly maxLockDaysPeriod: number = 365;
}
